import { makeStyles } from '@material-ui/core/styles';

export const goldSilverPaymentFormStyles = makeStyles(() => ({
  container: {
    flexDirection: 'column',
    display: 'flex',
    width: '100%',
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    padding: (props) => (props.mobile ? '' : '30px 70px'),
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    '& ul': {
      marginTop: 4,
      marginBottom: 6,
      '& li': {
        marginLeft: -22,
      },
    },
  },
  buttonSent: {
    margin: '0 auto',
    maxWidth: 200,
    width: 155,
  },
  divButtonLoading: {
    margin: 'auto',
  },
}));
